import * as React from 'react'
import { FieldHookConfig, useField } from 'formik'
import {
  TextField,
  OutlinedTextFieldProps,
  InputAdornment,
  IconButton,
} from '@mui/material'

import {
  KeyboardArrowDown,
  Visibility,
  VisibilityOff,
} from '@mui/icons-material'
import { menuProps } from '@/constants/mui'

interface Props extends Omit<OutlinedTextFieldProps, 'variant'> {}

export default function InputFormikPassword(
  props: Props & FieldHookConfig<string>,
) {
  const [field, meta, helpers] = useField(props)

  const { touched, error } = meta

  const showError = touched && Boolean(error)

  const { select, helperText, onChange } = props

  const [showPassword, setShowPassword] = React.useState(false)

  const newProps = {
    ...props,
    ...(select && {
      SelectProps: {
        IconComponent: KeyboardArrowDown,
        MenuProps: menuProps,
      },
    }),
  }

  const handleTypeField = (value: boolean) => {
    setShowPassword(value)
  }

  return (
    <TextField
      variant="outlined"
      margin="normal"
      fullWidth
      autoComplete="off"
      error={showError}
      {...newProps}
      {...field}
      onChange={(event: React.ChangeEvent<any>) => {
        onChange && onChange(event)
        helpers.setValue(event.target.value || '')
      }}
      value={field.value ? field.value : ''}
      helperText={showError ? error : helperText}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              size="small"
              aria-label="toggle visibility"
              onClick={(event) => handleTypeField(!showPassword)}
            >
              {showPassword ? (
                <Visibility fontSize="inherit" />
              ) : (
                <VisibilityOff fontSize="inherit" />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}
